export { default as StrategyMarkerCircle } from './StrategyMarkerCircle';
